import { render, staticRenderFns } from "./SpoiledPlaythrough.vue?vue&type=template&id=5f35084d&scoped=true&"
import script from "./SpoiledPlaythrough.vue?vue&type=script&lang=js&"
export * from "./SpoiledPlaythrough.vue?vue&type=script&lang=js&"
import style0 from "./SpoiledPlaythrough.vue?vue&type=style&index=0&id=5f35084d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f35084d",
  null
  
)

export default component.exports